import React from 'react';
import * as tags from './_recruit_page.tags';
import { RECRUIT, APPLICATION_DESCRIPTION } from './_recruit_page_constant';
import mobileTopVisualImage from '~/assets/recruit_page/mobile_recruit_page_visual.png';
import arrowImage from '~/assets/recruit_page/right_arrow.svg';

export const RecruitMain: React.FC = () => (
  <tags.RecruitMainWrapper>
    <tags.RecruitBoard>
      <tags.MobileTopVisual src={mobileTopVisualImage} />
      <tags.ContentsBoard>
        <tags.TitleContainer>
          <tags.Title>RECRUIT</tags.Title>
          <tags.TitleJP>採用情報</tags.TitleJP>
        </tags.TitleContainer>
        <tags.Category>インターン採用</tags.Category>
        <tags.TopicContainer>
          <tags.TopicTitle>業務内容</tags.TopicTitle>
          <tags.LongHorizontalLine />
        </tags.TopicContainer>
        <tags.JobDetail>{RECRUIT.INTERNSHIP.JOB}</tags.JobDetail>
        <tags.TopicContainer>
          <tags.TopicTitle>応募資格・条件</tags.TopicTitle>
          <tags.ShortHorizontalLine />
        </tags.TopicContainer>
        <tags.Theme>{RECRUIT.INTERNSHIP.REQUIREMENTS.THEME}</tags.Theme>
        <tags.RequirementsContainer>
          <tags.RequirementsDetailBox>
            {RECRUIT.INTERNSHIP.REQUIREMENTS.MANDATORY.map((mandatory) => (
              <tags.RequirementsDetail key={mandatory} letterSpacing={0.3}>
                {mandatory}
              </tags.RequirementsDetail>
            ))}
          </tags.RequirementsDetailBox>
          <tags.RequirementsDetailRightBox>
            {RECRUIT.INTERNSHIP.REQUIREMENTS.REQUEST.map((request) => (
              <tags.RequirementsDetail key={request} letterSpacing={0.3}>
                {request}
              </tags.RequirementsDetail>
            ))}
          </tags.RequirementsDetailRightBox>
        </tags.RequirementsContainer>
        <tags.Category>新卒/中途採用</tags.Category>
        <tags.TopicContainer>
          <tags.TopicTitle>業務内容</tags.TopicTitle>
          <tags.LongHorizontalLine />
        </tags.TopicContainer>
        <tags.JobDetail>{RECRUIT.NEW_HIRE.JOB}</tags.JobDetail>
        <tags.TopicContainer>
          <tags.TopicTitle>応募資格・条件</tags.TopicTitle>
          <tags.ShortHorizontalLine />
        </tags.TopicContainer>
        <tags.Theme>{RECRUIT.NEW_HIRE.REQUIREMENTS.THEME}</tags.Theme>
        <tags.DesktopSingleRequirementsDetail>
          ○ 必須条件　　　Word.Excel.PowerPointの基本作業できる方
        </tags.DesktopSingleRequirementsDetail>
        <tags.RequirementsContainer>
          <tags.MobileRequirementsDetailBox>
            {RECRUIT.NEW_HIRE.REQUIREMENTS.MANDATORY.map((mandatory) => (
              <tags.RequirementsDetail key={mandatory} letterSpacing={0.3}>
                {mandatory}
              </tags.RequirementsDetail>
            ))}
          </tags.MobileRequirementsDetailBox>
          <tags.RequirementsDetailBox>
            {RECRUIT.NEW_HIRE.REQUIREMENTS.REQUEST01.map((request) => (
              <tags.RequirementsDetail key={request} letterSpacing={0.2}>
                {request}
              </tags.RequirementsDetail>
            ))}
          </tags.RequirementsDetailBox>
          <tags.RequirementsDetailRightBox>
            {RECRUIT.NEW_HIRE.REQUIREMENTS.REQUEST02.map((request) => (
              <tags.RequirementsDetail key={request} letterSpacing={0.2}>
                {request}
              </tags.RequirementsDetail>
            ))}
          </tags.RequirementsDetailRightBox>
        </tags.RequirementsContainer>
        <tags.ApplicationContainer>
          <tags.ApplicationTitle>応募条件</tags.ApplicationTitle>
          <tags.ApplicationDescription>
            {APPLICATION_DESCRIPTION}
          </tags.ApplicationDescription>
          <tags.ApplicationAddress paddingBottom={0}>
            〒150-0001
          </tags.ApplicationAddress>
          <tags.ApplicationAddress paddingBottom={5.7}>
            東京都渋谷区神宮前1－10－34　
            <tags.MobileBr />
            原宿セントラルプレイス2/3F
            <br />
            株式会社REROOTS採用担当宛
          </tags.ApplicationAddress>
          <tags.ApplicationEmail>
            メールアドレス ： recruit_intern@reroots.co.jp
          </tags.ApplicationEmail>
          <tags.EmailButtonContainer href="mailto:recruit_intern@reroots.co.jp">
            <tags.LeftSideBox>
              <tags.ArrowContainer>
                <tags.Arrow src={arrowImage} alt=">" />
              </tags.ArrowContainer>
            </tags.LeftSideBox>
            <tags.RightSideBox>
              <tags.TextBox>メールを作成する</tags.TextBox>
            </tags.RightSideBox>
          </tags.EmailButtonContainer>
        </tags.ApplicationContainer>
      </tags.ContentsBoard>
    </tags.RecruitBoard>
  </tags.RecruitMainWrapper>
);
